module.exports = __webpack_public_path__ + "static/media/gloomy-sad.e99dfe56.png";